import HttpClientToken from '../../services/HttpClientToken';

import { defaultPlantilla, defaultPlantillaDetalle, ObtenerPlantillasAdminParams, ObtenerPlantillasParams, PlantillaAdminProps, PlantillaDetalleProps, PlantillaProps, PlantillaResponse } from '../../interfaces/admin/PlantillaInterface';

export const ObtenerPlantillasAdmin = ( params: ObtenerPlantillasAdminParams ) => {

    return new Promise<PlantillaAdminProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Plantilla/ObtenerPlantillasAdmin/', params, token)
            .then( ({ data } : { data : PlantillaAdminProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerPlantilla = ( params: ObtenerPlantillasParams ) => {

    return new Promise<PlantillaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Plantilla/ObtenerPlantilla', params, token)
            .then( ({ data } : { data : PlantillaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const AgregarPlantilla = ( params: PlantillaProps ) => {

    return new Promise<PlantillaResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Plantilla/AgregarPlantilla', params, token)
            .then( ({ data } : { data : PlantillaResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultPlantilla, message: 'Ocurrió un error, no se pudo guardar la plantilla. Contacte con el administrador' } );
            });

        }

    });

}

export const ActualizarPlantilla = ( params: PlantillaProps ) => {

    return new Promise<PlantillaResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Plantilla/ActualizarPlantilla', params, token)
            .then( ({ data } : { data : PlantillaResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultPlantilla, message: 'Ocurrió un error, no se pudo guardar la plantilla. Contacte con el administrador' } );
            });

        }

    });

}

export const ObtenerPlantillaDetalle = ( id: number ) => {

    return new Promise<PlantillaDetalleProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Plantilla/ObtenerPlantillaDetalle/${ id }`, token)
            .then( ({ data } : { data : PlantillaDetalleProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultPlantillaDetalle });
            });

        }

    });

}
